import React from "react";
import services from "../content/services";

/**
 * Render a description that may contain a `{placeholder}` token. If the
 * service has a `link`, the placeholder is replaced with an inline <a>.
 * Otherwise the description is rendered as-is.
 */
const renderDesc = (svc) => {
  if (!svc.link) return svc.desc;
  const parts = svc.desc.split(svc.link.placeholder);
  return (
    <>
      {parts[0]}
      <a
        href={svc.link.url}
        target="_blank"
        rel="noopener noreferrer"
        data-analytics-event={svc.link.analyticsEvent}
      >
        {svc.link.text}
      </a>
      {parts[1]}
    </>
  );
};

const Services = ({ classicHeader, darkTheme }) => {
  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {renderDesc(service)}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
